import { Avatar } from '../../components/Avatar'
import { Text } from '../../components/Text'
import { useI18n } from '../../i18n'

/**
 * Home header: avatar (initials) + greeting eyebrow over the user's name, with
 * the signed-in email underneath.
 *
 * The name-edit pencil is omitted until that screen exists — a control with no
 * destination reads as broken.
 *
 * Full-bleed white row — it sits flush to the edges of the home column while the
 * cards below carry their own horizontal padding.
 */
export function UserInfoHeader({
  name,
  email,
}: {
  name: string
  email?: string
}) {
  const { t } = useI18n()

  return (
    <div className="flex items-center gap-4 bg-white px-6 py-6">
      <Avatar name={name} />

      <div className="min-w-0 flex-1">
        <Text as="p" variant="sm" className="text-gray-600">
          {t('splash.welcome')}
        </Text>
        <Text
          as="p"
          variant="lg"
          weight="semibold"
          className="truncate text-gray-900"
        >
          {name}
        </Text>
        {email && (
          <Text as="p" variant="caption" className="truncate text-gray-600">
            {email}
          </Text>
        )}
      </div>
    </div>
  )
}
